import { LocationMembership } from './membership';
import axios from 'axios'
import config from '../config'
import { ok } from 'assert';

interface IGroup {
  name ?: string;
  _id: string;
}

interface ICommunity {
  groups?: IGroup[];
}

export interface IBuilderSettings {
  id: string;
  locationId: string;
  userId: string | null;
  downloadOption: boolean;
  appSettings: object | null;
  pwaEnabled: boolean | false;
  createdAt: Date;
  updatedAt: Date;
}

export class LocationCommunity {

  private locationId: string;

  static get headers() {
    return {
      channel: 'APP',
      source: 'WEB_USER',
      version: '2021-07-28',
      ContentType: 'application/json',
    }
  }

  public groups : ReadonlyArray<IGroup> = [];

  private constructor(locationId: string){
    this.locationId = locationId;
  }

  public static async fetchAllActiveGroups(locationId: string){

    const community = new LocationCommunity(locationId);
    
    try {
      let response = await axios.get<IGroup[]>(`${config.communitiesUrl}/${locationId}/groups?limit=1000` , {
        headers: this.headers
      });
      if(response.data) community.groups = response.data;
      
    } catch (err) {
      console.info(`Error fetching membership information for location - ${locationId}`);
      console.log(err);
    }
    return community;
  }
}
